import gsap, { ScrollTrigger, ScrollSmoother, SplitText } from "gsap/all";

const PageExhibit = ($) => {
	if ($("main").hasClass("exhibit")) {
		gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);

		let smoother = ScrollSmoother.create({
			smooth: 0.3, // scroll smoothness, default 0.1
			effects: true,
		});

		// getting all the exhibit card blocks
		let exhibitCardBlocks = gsap.utils.toArray(".exhibit-card-block");

		if(exhibitCardBlocks.length === 0) {
			return;
		}

		// looping through all the exhibit card blocks
		exhibitCardBlocks.forEach((block) => {
			const image = block.querySelector(".exhibit-card-block__image");
			const title = block.querySelector("#exhibit-card-block__title");

			const text = block.querySelectorAll(
				".exhibit-card-block__content__paragraphs p"
			);

			// animation that title and text share
			const titleTextAnimation = { opacity: 0, y: 25, ease: "back" };

			// timeline for image rotation reset and text animation
			const imageTextTimeline = gsap.timeline({
				scrollTrigger: {
					trigger: image,
					start: "top center",
					end: "bottom center",
				},
			});

			imageTextTimeline.to(image, {
				rotation: 0,
			});

			imageTextTimeline.from(title, titleTextAnimation);

			// start 0.2 second after previous tween begins
			text.forEach((paragraph) => {
				imageTextTimeline.from(paragraph, titleTextAnimation, "<0.2");
			});

			let hoverOverlay = $(".exhibit__hover-overlay")[0];

			// timeline for animation for exhibit card images on hover
			let hoverTimeline = gsap.timeline({ paused: true });

			hoverTimeline.to(
				image,
				{
					scale: 1.2,
					rotation: 0,
					zIndex: 10000,
					delay: 0.2,
				},
				"start"
			);

			hoverTimeline.to(
				hoverOverlay,
				{
					opacity: 0.5,
					delay: 0.2,
				},
				"start"
			);

			if (image) {
				image.addEventListener("mouseenter", () => hoverTimeline.play());
				image.addEventListener("mouseleave", () => hoverTimeline.reverse());
			}
		});
	}
};

export default PageExhibit;
